import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { CommandPalette } from '@/components/command/CommandPalette';
import { ActivityPanel } from '@/components/activity/ActivityPanel';
import { Toaster } from '@/components/ui/Toaster';

export function AppShell() {
  return (
    <div className="h-screen flex bg-bg text-fg">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <ActivityPanel />
      <Toaster />
    </div>
  );
}

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow?: string;
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <div className="px-4 md:px-6 lg:px-8 pt-6 md:pt-8 pb-5 border-b border-border bg-bg-elevated">
      {eyebrow && (
        <div className="text-2xs uppercase tracking-wider font-semibold text-accent mb-1.5">
          {eyebrow}
        </div>
      )}
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-xl md:text-2xl font-semibold text-fg tracking-tight">{title}</h1>
          {description && (
            <p className="text-sm text-fg-muted mt-1 max-w-2xl leading-relaxed">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap shrink-0">{actions}</div>}
      </div>
    </div>
  );
}

export function PageBody({ children }: { children: React.ReactNode }) {
  return <div className="px-4 md:px-6 lg:px-8 py-5 md:py-6 max-w-[1280px]">{children}</div>;
}
